import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Avatar from 'react-avatar-edit'

const SettingsAvatarForm = ({
    avatar,
    title,
    onClose,
    onCrop,
    onBeforeFileLoad,
    onSave,
    processing = false,
    errors = {}
}) => {
    
    return (
        <form className="col-md-12 mt-md-5">
            {title ?
                (<React.Fragment>
                    <h2>{title}</h2>
                    <hr /> 
                </React.Fragment>)
                : ""
            }
            {errors.onAvatarSave && (
                <div className="alert alert-danger" role="alert">
                    {errors.onAvatarSave}
                </div>
            )}
            <div className="row">
                <div className="col-md-8">
                    <Avatar
                        width={390}
                        imageWidth={390}
                        onCrop={onCrop}
                        onClose={onClose}
                        onBeforeFileLoad={onBeforeFileLoad}
                        src={avatar.src}

                        />
                </div>
                <div className="col-md-4">
                    <h5>Preview</h5>
                    {avatar.preview ? <img src={avatar.preview} alt="Preview" style={{ height: 150, width: 150 }} /> : ""}
                </div>
            </div>
            <button type="submit" onClick={onSave} className="btn btn-info float-right" >
                Save
            </button>
        </form>
    );
}

SettingsAvatarForm.propTypes = {

}

export default SettingsAvatarForm;



// WEBPACK FOOTER //
// ./src/components/user/SettingsAvatarForm.js